import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-Unauthorized',
    templateUrl: 'unauthorized.component.html'
})

export class UnAuthorizedComponent implements OnInit {
    constructor() { }

    ngOnInit() { }
}